
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|1792|5008|646)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
